const apiBasePath = 'http://aztektec.com.mx:9080/aztek-kiosko-factura-sapo'; //PROD
// const apiBasePath = 'http://siereportes.dyndns.org:9080/aztek-kiosko-factura-tlalne'; //DEV

// Constants for SessionStorage
const sessionStorageKey_session = 'session';
const sessionStorageKey_menuRoutes = 'contextMenuRoutes';

const themeColor = {
  token: {
    colorPrimary: '#203421', // Custom primary color
    colorBgBase: '#fff', // Base background for the whole app
    colorTextBase: '#333', // Base text color
    colorBgContainer: '#fff', // Container background (e.g., for cards or forms)
    colorBorder: '#E3E3E3', // Border color for inputs, cards, etc.
    colorTextPlaceholder: '#333', // Placeholder text color
    colorLink: '#203421' // Link color
  },
  components: {
    Layout: {
      headerBg: '#fff', // Header background color
      headerColor: '#333', // Header text color
      footerBg: '#203421', // Footer background
      footerColor: '#fff' // Footer text
    },
    Menu: {
      colorItemBg: '#fff', // Menu background
      colorItemText: '#203421', // Menu text
      colorItemTextHover: '#203421' // Menu text hover
    }
  }
};

const MENU_CUSTOMER = [
  {
    description: 'Facturación',
    item: [
      { path: 'invoice-tickets', description: 'Boletaje' }
      // { path: 'invoice-storage', description: 'Pensiones' }
    ]
  },
  { path: 'invoice-list', description: 'Mis Facturas' }
];

const MENU_ADMIN = [
  {
    description: 'Facturación',
    item: [{ path: 'invoice-tickets', description: 'Boletaje/Pensiones' }]
  },
  { path: 'invoice-monitor', description: 'Monitor Facturas' },
  {
    description: 'Mantenimiento',
    item: [{ path: 'client-list', description: 'Clientes' }]
  }
];

const optionRoles = {
  isCorporate: 0,
  isOperator: 0,
  isSupervisor: 0,
  isSystem: 0
};

const CAR_STORAGE_FETCH_INFO = {
  method: 'post',
  url: 'income',
  sendIncomeValues: {
    active: 1,
    comment: '',
    incomeStatusOid: 1,
    incomeTypeOid: 2
  }
};

const DICCIONARIO_COLOR_STATUS_INCOMES = {
  0: {
    'Pendiente TF': {
      null: 'orange',
      error: 'red'
    }
  },
  1: {
    1: {
      null: 'green',
      error: 'purple'
    }
  }
};

const BACK_OFFICE_STATES = [2, 3, 4, 5];

const DEFAULT_TABLE_EMPTY_MSG = (
  <div className="custom-table-empty-message">
    <p>
      <b>No se encontraron datos disponibles.</b>
    </p>
    <p>Por favor, ingrese la información necesaria para continuar.</p>
  </div>
);

const CAR_STORAGE_TABLE_EMPTY_MSG = (
  <div className="custom-table-empty-message">
    <p>
      <b>No se encontraron registros en este período</b>
    </p>
    <p>Por favor, seleccione otro período para continuar.</p>
  </div>
);

const ACTIVE = 1;
const STORAGE_INCOME_TYPE_OID = 2;

export {
  themeColor,
  apiBasePath,
  sessionStorageKey_session,
  sessionStorageKey_menuRoutes,
  optionRoles,
  ACTIVE,
  BACK_OFFICE_STATES,
  CAR_STORAGE_FETCH_INFO,
  CAR_STORAGE_TABLE_EMPTY_MSG,
  DEFAULT_TABLE_EMPTY_MSG,
  DICCIONARIO_COLOR_STATUS_INCOMES,
  STORAGE_INCOME_TYPE_OID,
  MENU_CUSTOMER,
  MENU_ADMIN
};
